"use client";

interface DataLayerProps {
  event?: string;
  param1?: string;
  param2?: string;
  param4?: string;
  gigyaID?: string;
}

/***
 * To add the Data Layer
 */
export const addDataLayer = ({
  event,
  param1,
  gigyaID,
  param2,
  param4,
}: DataLayerProps) => {
  if (typeof window !== "undefined") {
    (window as any).dataLayer.push({
      event: event,
      ...(gigyaID ? { gigyaID } : {}),
      param1: param1,
      param2: param2,
      param4: param4,
    });
  }
};

export const addDataLayerPostLogin = ({ event, gigyaID }: DataLayerProps) => {
  if (typeof window !== "undefined") {
    (window as any).dataLayer.push({
      event: event,
      gigyaID,
    });
  }
};
